import * as yup from "yup";

export const bulkDeleteEventsFormSchema = yup
  .object({
    eventIds: yup
      .array()
      .of(yup.number().required())
      .min(1, "Поне едно събитие трябва да бъде избрано.")
      .required(),
  })
  .required();

export type IBulkDeleteEventsFormModel = yup.InferType<
  typeof bulkDeleteEventsFormSchema
>;

export const bulkDeleteEventsFormDefaultValues: IBulkDeleteEventsFormModel = {
  eventIds: [],
};
